module.exports = __webpack_public_path__ + "static/media/default-image.f8873e45.svg";